import { createFeature, createReducer, on } from '@ngrx/store';
import { IrGeneratorActions } from './ir-generator.actions';
import { IrGeneratorState } from './ir-generator.model';

const initialState: IrGeneratorState = {
  queries: [{ id: 1, label: 'Query 1', prompt: '', isLoading: false }],
  nextId: 2,
};

export const irGeneratorFeatureKey = 'irGenerator';

export const irGeneratorReducer = createReducer(
  initialState,

  on(IrGeneratorActions.addQuery, (state) => ({
    ...state,
    queries: [
      ...state.queries,
      {
        id: state.nextId,
        label: `Query ${state.nextId}`,
        prompt: '',
        isLoading: false,
      },
    ],
    nextId: state.nextId + 1,
  })),

  on(IrGeneratorActions.generateIR, (state, { id, prompt }) => ({
    ...state,
    queries: state.queries.map((query) =>
      query.id === id
        ? { ...query, prompt, isLoading: true, error: null }
        : query,
    ),
  })),

  on(IrGeneratorActions.generateIRSuccess, (state, { id, response }) => ({
    ...state,
    queries: state.queries.map((query) =>
      query.id === id ? { ...query, isLoading: false, response } : query,
    ),
  })),

  on(IrGeneratorActions.generateIRFailure, (state, { id, error }) => ({
    ...state,
    queries: state.queries.map((query) =>
      query.id === id ? { ...query, isLoading: false, error } : query,
    ),
  })),

  on(IrGeneratorActions.resetState, () => initialState),
);

export const irGeneratorFeature = createFeature({
  name: irGeneratorFeatureKey,
  reducer: irGeneratorReducer,
});
